module.exports = __webpack_public_path__ + "static/media/pa.2c6a7093.png";